import classnames from 'classnames'
import React from 'react'
import { Icon } from '../../icon'
import styles from './checkbox-v3.module.scss'

interface CheckboxV3Props {
  checked?: boolean
  disabled?: boolean
  className?: string
  onChange?: () => void
}

export const CheckboxV3: React.FC<CheckboxV3Props> = ({
  checked = false,
  disabled = false,
  className,
  onChange
}) => (
  <button
    type="button"
    role="checkbox"
    aria-checked={checked}
    disabled={disabled}
    className={classnames(styles.checkbox, className, {
      [styles.checked]: checked,
      [styles.disabled]: disabled
    })}
    onClick={onChange}
  >
    {checked && (
      <Icon name="check" width={18} height={18} className={styles.icon} />
    )}
  </button>
)
